import PadronClassic from '../images/padron-clasik.jpg'
import padron1864 from '../images/padron/PadronSeries.png'
import Padron50thAnn from '../images/padron/Padron50thAnn.png'
import Damaso from '../images/padron/Damaso.png'
import Padron_1964Ann from '../images/padron/Padron_1964AnnSeries_Hm.png';
import Padron1926 from '../images/padron/Padron1926.png'
import PadronFR_No45 from '../images/padron/PadronFR_No45.png'
import PadronSeries_Hdr from '../images/padron/PadronSeries_Hdr.jpg'
import padron3 from '../images/padron/1964-3.png'
import Padron_Damaso from '../images/padron/Padron_Damaso.jpg'
import Padron_1964 from '../images/padron/Padron_1964.jpg'
import Padron_1926 from '../images/padron/Padron_1926.jpg'
import Padron_FamReserev from '../images/padron/Padron_FamReserev.jpg'
import Padron_50Anniversary from '../images/padron/Padron_50Anniversary.jpg'
import Padron_Magnum2 from '../images/padron/Series/Padron_Magnum2.jpg'
import Padron_Executive from '../images/padron/Series/Padron_Executive.jpg'
import Churchill from '../images/padron/Series/Churchill.jpg'
import Ambassador from '../images/padron/Series/Ambassador.jpg'
import Panetela from '../images/padron/Series/Panetela.jpg'
import P4000 from '../images/padron/Series/4000.jpg'
import Palmas from '../images/padron/Series/Palmas.jpg'
import P7000 from '../images/padron/Series/P7000.jpg'
import P6000 from '../images/padron/Series/P6000.jpg'
import P5000 from '../images/padron/Series/P5000.jpg'
import P3000 from '../images/padron/Series/P3000.jpg'
import Londres from '../images/padron/Series/Londres.jpg'
import P2000 from '../images/padron/Series/P2000.jpg'
import Delicias from '../images/padron/Series/Delicias.jpg'
import Corticos from '../images/padron/Series/Cortico.jpg'

// padron images
import PadronMagnumClosed from '../images/padron/Series/Padron_MagnumClosed.jpg'
import PadronMagnumOpen from '../images/padron/Series/Padron_MagnumOpen.jpg'

import Padron_ExecutiveClosed from '../images/padron/Series/Padron_ExecutiveClosed.jpg'
import Padron_ExecutiveOpen from '../images/padron/Series/Padron_ExecutiveOpen.jpg'

import Padron_ChurchillClosed from '../images/padron/Series/Padron_ChurchillClosed.jpg'
import Padron_ChurchillOpen from '../images/padron/Series/Padron_Churchill_Open.jpg'

import AmbassadorClosed from '../images/padron/Series/AmbassadorClosed.jpg'
import AmbassadorOpen1 from '../images/padron/Series/AmbassadorOpen1.jpg'

import PanetelaClosed from '../images/padron/Series/PanetelaClosed.jpg'
import PanetelaOpen from '../images/padron/Series/PanetelaOpen.jpg'

import P4000Closed from '../images/padron/Series/Padron_4000Closed.jpg'
import P4000Open from '../images/padron/Series/PadronSeries_4000.jpg'

import PalmasClosed from '../images/padron/Series/PalmasClosed.jpg'
import PalmasOpen from '../images/padron/Series/PalmasOpen.jpg'

import Padron_7000Closed from '../images/padron/Series/Padron_7000Closed.jpg'
import Padron_7000Open from '../images/padron/Series/Padron_7000Open.jpg'

import Padron_6000Closed from '../images/padron/Series/Padron_6000Closed.jpg'
import Padron_6000Open from '../images/padron/Series/Padron_6000Open.jpg'

import Padron_5000Closed from '../images/padron/Series/Padron_5000Closed.jpg'
import Padron_5000Open from '../images/padron/Series/Padron_5000Open.jpg'

import Padron_3000Closed from '../images/padron/Series/Padron_3000Closed.jpg'
import Padron_3000Open from '../images/padron/Series/Padron_3000Open.jpg'

import Padron_LondresClosed from '../images/padron/Series/Padron_LondresClosed.jpg'
import Padron_LondresOpen from '../images/padron/Series/Padron_LondresOpen.jpg'

import Padron_2000Closed from '../images/padron/Series/Padron_2000Closed.jpg'
import Padron_2000Open from '../images/padron/Series/Padron_2000Open.jpg'

import Padron_DeliciasClosed from '../images/padron/Series/Padron_DeliciasClosed.jpg'
import Padron_DeliciasOpen from '../images/padron/Series/Padron_DeliciasOpen.jpg'

import Padron_CorticClosed from '../images/padron/Series/Padron_CorticosClosed30.jpg'
import Padron_CorticOpen from '../images/padron/Series/Padron_CorticosOpen30.jpg'

//Damaso images
import DamasoNo17 from '../images/padron/Damaso/DamasoNo17.jpg';
import Damaso_No17Open from '../images/padron/Damaso/Damaso_No17Open.jpg'
import Damaso_No17Close from '../images/padron/Damaso/Damaso_No17Closed.jpg'

import DamasoNo15 from '../images/padron/Damaso/DamasoNo15.jpg';
import Damaso_No15Open from '../images/padron/Damaso/Damaso_No15Open_1.jpg'
import Damaso_No15Close from '../images/padron/Damaso/Damaso_No15_Closed2.jpg'

import DamasoNo8 from '../images/padron/Damaso/DamasoNo8.jpg';
import Damaso_No8Open from '../images/padron/Damaso/Damaso_No8Open1.jpg'
import Damaso_No8Close from '../images/padron/Damaso/Damaso_No8Closed.jpg'

import DamasoNo12 from '../images/padron/Damaso/DamasoNo12.jpg';
import Damaso_No12Open from '../images/padron/Damaso/Damaso_No12Open.jpg'
import Damaso_No12Close from '../images/padron/Damaso/Damaso_No12Close.jpg'

import DamasoNo34 from '../images/padron/Damaso/DamasoNo34.jpg';
import Damaso_No34Open from '../images/padron/Damaso/Damaso_No34_Open.jpg'
import Damaso_No34Close from '../images/padron/Damaso/Damaso_No34Closed.jpg'

import DamasoNo32 from '../images/padron/Damaso/DamasoNo34.jpg';
import Damaso_No32Open from '../images/padron/Damaso/Damaso_No34_Open.jpg'
import Damaso_No32Close from '../images/padron/Damaso/Damaso_No34Closed.jpg'

//Anniversary 1964
import A from '../images/padron/1964/1964Ann_А.jpg';
import Padron_1964AOpen from '../images/padron/1964/Padron_1964AOpen.jpg'
import Padron_1964AClosed from '../images/padron/1964/Padron_1964AClosed.jpg'

import Diplomatico from '../images/padron/1964/Diplomatico.jpg';
import DiplomaticoOpen from '../images/padron/1964/DiplomaticoOpen.jpg'
import DiplomaticoClosed from '../images/padron/1964/DiplomaticoClosed.jpg'

import Piramide from '../images/padron/1964/Piramide.jpg';
import PiramideOpen from '../images/padron/1964/PiramideOpen.jpg'
import PiramideClosed from '../images/padron/1964/PiramideClosed.jpg'

import Monarca from '../images/padron/1964/Monarca.jpg';
import MonarcaOpen from '../images/padron/1964/MonarcaOpen.jpg'
import MonarcaClosed from '../images/padron/1964/MonarcaClosed.jpg'

import Superior from '../images/padron/1964/Superior.jpg';
import SuperiorOpen from '../images/padron/1964/SuperiorOpen.jpg'
import SuperiorClosed from '../images/padron/1964/SuperiorClosed.jpg'

import No4 from '../images/padron/1964/No4.jpg';
import No4Open from '../images/padron/1964/No4Open.jpg'
import No4Closed from '../images/padron/1964/No4Closed.jpg'

import Torpedo from '../images/padron/1964/Torpedo.jpg';
import TorpedoOpen from '../images/padron/1964/TorpedoOpen.jpg'
import TorpedoClosed from '../images/padron/1964/TorpedoClosed.jpg'

import Imperial from '../images/padron/1964/Imperial.jpg';
import ImperialOpen from '../images/padron/1964/ImperialOpen.jpg'
import ImperialClosed from '../images/padron/1964/ImperialClosed.jpg'

import Corona from '../images/padron/1964/Corona.jpg';
import CoronaOpen from '../images/padron/1964/CoronaOpen.jpg'
import CoronaClosed from '../images/padron/1964/CoronaClosed.jpg'

import Presidente from '../images/padron/1964/Presidente.jpg';
import PresidenteOpen from '../images/padron/1964/PresidenteOpen.jpg'
import PresidenteClosed from '../images/padron/1964/PresidenteClosed.jpg'

import Exclusivo from '../images/padron/1964/Exclusivo.jpg';
import ExclusivoOpen from '../images/padron/1964/ExclusivoOpen.jpg'
import ExclusivoClosed from '../images/padron/1964/ExclusivoClosed.jpg'

import Belicoso from '../images/padron/1964/Belicoso.jpg';
import BelicosoOpen from '../images/padron/1964/BelicosoOpen.jpg'
import BelicosoClosed from '../images/padron/1964/BelicosoClosed.jpg'

import Toro from '../images/padron/1964/Toro.jpg';
import ToroOpen from '../images/padron/1964/ToroOpen.jpg'
import ToroClosed from '../images/padron/1964/ToroClosed.jpg'

import Soberano from '../images/padron/1964/Soberano.jpg';
import SoberanoOpen from '../images/padron/1964/SoberanoOpen.jpg'
import SoberanoClosed from '../images/padron/1964/SoberanoClosed.jpg'

import Principe from '../images/padron/1964/Principe.jpg';
import PrincipeOpen from '../images/padron/1964/PrincipeOpen.jpg'
import PrincipeClosed from '../images/padron/1964/PrincipeClosed.jpg'

import Hermoso from '../images/padron/1964/Hermoso.jpg';
import HermosoOpen from '../images/padron/1964/HermosoOpen.jpg'
import HermosoClosed from '../images/padron/1964/HermosoClosed.jpg'

// 1926
import No1 from '../images/padron/1926/No1.jpg'
import No1Open from '../images/padron/1926/No1Open.jpg'
import No1Closed from '../images/padron/1926/No1Closed.jpg'

import No9 from '../images/padron/1926/No9.jpg'
import No9Open from '../images/padron/1926/No9Open.jpg'
import No9Closed from '../images/padron/1926/No9Closed.jpg'

import No2 from '../images/padron/1926/No2.jpg'
import No2Open from '../images/padron/1926/No2Open.jpg'
import No2Closed from '../images/padron/1926/No2Closed.jpg'

import No6 from '../images/padron/1926/No6.jpg'
import No6Open from '../images/padron/1926/No6Open.jpg'
import No6Closed from '../images/padron/1926/No6Closed.jpg'

import No35 from '../images/padron/1926/No35.jpg'
import No35Open from '../images/padron/1926/No35Open.jpg'
import No35Closed from '../images/padron/1926/No35Closed.jpg'

import No40 from '../images/padron/1926/No40.jpg'
import No40Open from '../images/padron/1926/No40Open.jpg'
import No40Closed from '../images/padron/1926/No40Closed.jpg'

//Family reserved
import No44 from '../images/padron/Family/No44.jpg'
import No44Open from '../images/padron/Family/No44Open.jpg'
import No44Closed from '../images/padron/Family/No44Closed.jpg'

import No45 from '../images/padron/Family/No45.jpg'
import No45Open from '../images/padron/Family/No45Open.jpg'
import No45Closed from '../images/padron/Family/No45Closed.jpg'

import No46 from '../images/padron/Family/No46.jpg'
import No46Open from '../images/padron/Family/No46Open.jpg'
import No46Closed from '../images/padron/Family/No46Closed.jpg'

import No85 from '../images/padron/Family/No85.jpg'
import No85Open from '../images/padron/Family/No85Open.jpg'
import No85Closed from '../images/padron/Family/No85Closed.jpg'


import No50 from '../images/padron/Family/No50.jpg'
import No50Open from '../images/padron/Family/No50Open.jpg'
import No50Closed from '../images/padron/Family/No50Closed.jpg'

import Padron_50 from '../images/padron/50th/Padron_50.jpg'
import Padron_50Open from '../images/padron/50th/Padron_50Open.jpg'
import Padron_50Closed from '../images/padron/50th/Padron_50Closed.jpg'

import Padron from '../pages/Cigars/Padron';

export const PadronData = [
    {
        id: 1,
        title: 'Padrón Series',
        subTitle: 'Основана през 1964 г. и развиваща се през цялата ни история, серията Padrón днес се състои от петнадесет пури със средно до пълно тяло с дълго пълнене, вариращи от Cortico до големи Magnum. Красиво балансиран и пълноценен дим с изключително качество и стойност, линията Padrón отлежава минимум две години и половина. Както при всички наши изключителни предложения за пури, тази линия е ръчно изработена, използвайки само отглеждан на слънце тютюн.',
        imgUrl: padron1864,
        imagBg: PadronSeries_Hdr,

        cigars: [
            {
                id: 1,
                title: 'Magnum',
                subtitle: '50 x 9',
                img: Padron_Magnum2,
                openBox: PadronMagnumOpen,
                closedBox: PadronMagnumClosed,
            },
            {
                id: 2,
                title: 'Executive',
                subtitle: '50 x 7 1/2',
                img: Padron_Executive,
                openBox: Padron_ExecutiveOpen,
                closedBox: Padron_ExecutiveClosed,
            },
            {
                id: 3,
                title: 'Churchill',
                subtitle: '46 x 6 7/8',
                img: Churchill,
                openBox: Padron_ChurchillOpen,
                closedBox: Padron_ChurchillClosed,
            },
            {
                id: 4,
                title: 'Ambassador',
                subtitle: '42 x 6 7/8',
                img: Ambassador,
                openBox: AmbassadorOpen1,
                closedBox: AmbassadorClosed,
            },
            {
                id: 5,
                title: 'Panetela',
                subtitle: '36 x 6 7/8',
                img: Panetela,
                openBox: PanetelaOpen,
                closedBox: PanetelaClosed,
            },
            {
                id: 6,
                title: '4000',
                subtitle: '54 x 6 1/2',
                img: P4000,
                openBox: P4000Open,
                closedBox: P4000Closed,
            },
            {
                id: 7,
                title: 'Palmas',
                subtitle: '54 x 6 1/2',
                img: Palmas,
                openBox: PalmasOpen,
                closedBox: PalmasClosed,
            },
            {
                id: 8,
                title: '7000',
                subtitle: '60 x 6 1/4',
                img: P7000,
                openBox: Padron_7000Open,
                closedBox: Padron_7000Closed,
            },
            {
                id: 9,
                title: '6000',
                subtitle: '52 x 5 1/2',
                img: P6000,
                openBox: Padron_6000Open,
                closedBox: Padron_6000Closed,
            },
            {
                id: 10,
                title: '5000',
                subtitle: '56 x 5 1/2',
                img: P5000,
                openBox: Padron_5000Open,
                closedBox: Padron_5000Closed,
            },
            {
                id: 11,
                title: '3000',
                subtitle: '52 x 5 1/2',
                img: P3000,
                openBox: Padron_3000Open,
                closedBox: Padron_3000Closed,
            },
            {
                id: 12,
                title: 'Londres',
                subtitle: '42 x 5 1/2',
                img: Londres,
                openBox: Padron_LondresOpen,
                closedBox: Padron_LondresClosed,
            },
            {
                id: 13,
                title: '2000',
                subtitle: '50 x 5',
                img: P2000,
                openBox: Padron_2000Open,
                closedBox: Padron_2000Closed,
            },
            {
                id: 14,
                title: 'Delicias',
                subtitle: '42 x 5 1/2',
                img: Delicias,
                openBox: Padron_DeliciasOpen,
                closedBox: Padron_DeliciasClosed,
            },
            {
                id: 15,
                title: 'Corticos',
                subtitle: '42 x 5 1/2',
                img: Corticos,
                openBox: Padron_CorticOpen,
                closedBox: Padron_CorticClosed,
            }
        ]
    },
    {
        id: 2,
        title: 'Damaso',
        subTitle: 'Дамасо Падрон ни даде живот, семейство и нашето начало в тази индустрия. Той беше първият Падрон, пристигнал в Куба в края на 1800 г. от Канарските острови - в негова чест предлагаме тази пура. Тази кръгла, мека, ароматна, ръчно изработена и ограничена производствена пура се произвежда с еквадорска обвивка от Кънектикът и се предлага в шест размера. За тези, които предпочитат по-здрав вкусов профил, ние предлагаме „Red Label“ Dámaso No. 34 и No. 32.',
        paragraphOne: `
        За да създадем нещо ново, ние погледнахме към миналото си. Линията пури Dámaso предлага сложен мек до среден вкусов профил, изработен в продължение на пет поколения.
        `,
        imgUrl: Damaso,
        imagBg: Padron_Damaso,
        cigars: [
            {
                id: 1,
                title: 'No 17',
                subtitle: '54 x 7',
                img: DamasoNo17,
                openBox: Damaso_No17Open,
                closedBox: Damaso_No17Close,
            },
            {
                id: 2,
                title: 'No 15',
                subtitle: '52 x 6',
                img: DamasoNo15,
                openBox: Damaso_No15Open,
                closedBox: Damaso_No15Close,
            },
            {
                id: 3,
                title: 'No 8',
                subtitle: '46 x 5 1/2',
                img: DamasoNo8,
                openBox: Damaso_No8Open,
                closedBox: Damaso_No8Close,
            },
            {
                id: 4,
                title: 'No 12',
                subtitle: '50 x 5',
                img: DamasoNo12,
                openBox: Damaso_No12Open,
                closedBox: Damaso_No12Close,
            },
            {
                id: 5,
                title: 'No 34 Red Label',
                subtitle: '52 x 6',
                img: DamasoNo34,
                openBox: Damaso_No34Open,
                closedBox: Damaso_No34Close,
            },
            {
                id: 6,
                title: 'No 32 Red Label',
                subtitle: '52 x 5 1/5',
                img: DamasoNo32,
                openBox: Damaso_No32Open,
                closedBox: Damaso_No32Close,
            }
        ]

    },
    {
        id: 3,
        title: 'Padrón 1964 Anniversary Series',
        subTitle: 'Линията Padrón 1964 Anniversary Series е представена през 1994 г., за да отбележи 30-годишнината на нашата компания. Тази линия се състои от шестнадесет размера, всички налични в отгледани от слънце естествени и мадурови опаковки.',
        paragraphOne: `
        Всички тютюни, използвани в тази ограничена производствена серия, отлежават четири години, създавайки гладък и сложен вкус. В чест на вековната кубинска традиция на пури за пресоване на кутии, линията от 1964 г. е въведена като серия с пресовани кутии. За защита на нашите клиенти въведохме мерки за предпазване от фалшифициране със специално проектирана двойна лента с индивидуално номериран гаранционен етикет.
        `,
        paragraphTwo: `
        Серията Padrón 1964 Anniversary последователно се класира от индустриалните експерти като една от най-добрите марки в света.
        `,
        imgUrl: Padron_1964Ann,
        imagBg: Padron_1964,
        cigars: [
            {
                id: 1,
                title: '"A"',
                subtitle: '50 x 8 1/4',
                img: A,
                openBox: Padron_1964AOpen,
                closedBox: Padron_1964AClosed
            },
            {
                id: 2,
                title: 'Diplomatico',
                subtitle: '50 x 7',
                img: Diplomatico,
                openBox: DiplomaticoOpen,
                closedBox: DiplomaticoClosed,
            },
            {
                id: 3,
                title: 'Piramide',
                subtitle: '52 x 42 x 6 7/8',
                img: Piramide,
                openBox: PiramideOpen,
                closedBox: PiramideClosed,
            },
            {
                id: 4,
                title: 'Monarca',
                subtitle: '46 x 6 1/2',
                img: Monarca,
                openBox: MonarcaOpen,
                closedBox: MonarcaClosed,
            },
            {
                id: 5,
                title: 'Superior',
                subtitle: '42 x 6 1/2',
                img: Superior,
                openBox: SuperiorOpen,
                closedBox: SuperiorClosed,
            },
            {
                id: 6,
                title: 'No 4',
                subtitle: '60 x 6 1/2',
                img: No4,
                openBox: No4Open,
                closedBox: No4Closed,
            },
            {
                id: 7,
                title: 'Torpedo',
                subtitle: '52 x 6',
                img: Torpedo,
                openBox: TorpedoOpen,
                closedBox: TorpedoClosed,
            },
            {
                id: 8,
                title: 'Imperial',
                subtitle: '54 x 6',
                img: Imperial,
                openBox: ImperialOpen,
                closedBox: ImperialClosed,
            },
            {
                id: 9,
                title: 'Corona',
                subtitle: '54 x 6',
                img: Corona,
                openBox: CoronaOpen,
                closedBox: CoronaClosed,
            },
            {
                id: 10,
                title: 'Presidente',
                subtitle: '50 x 6',
                img: Presidente,
                openBox: PresidenteOpen,
                closedBox: PresidenteClosed,
            },
            {
                id: 11,
                title: 'Exclusivo',
                subtitle: '50 x  5 1/2',
                img: Exclusivo,
                openBox: ExclusivoOpen,
                closedBox: ExclusivoClosed,
            },
            {
                id: 12,
                title: 'Belicoso',
                subtitle: '52 x  5',
                img: Belicoso,
                openBox: BelicosoOpen,
                closedBox: BelicosoClosed,
            },
            {
                id: 13,
                title: 'Toro',
                subtitle: '56 x 5   TAA Exclusive Release*',
                img: Toro,
                openBox: ToroOpen,
                closedBox: ToroClosed,
            },
            {
                id: 14,
                title: 'Soberano',
                subtitle: '52 x 5',
                img: Soberano,
                openBox: SoberanoOpen,
                closedBox: SoberanoClosed,
            },
            {
                id: 15,
                title: 'Principe',
                subtitle: '46 x 4 1/2',
                img: Principe,
                openBox: PrincipeOpen,
                closedBox: PrincipeClosed,
            },
            {
                id: 16,
                title: 'Hermoso',
                subtitle: '56 x 4',
                img: Hermoso,
                openBox: HermosoOpen,
                closedBox: HermosoClosed,
            }
        ]
    },
    {
        id: 4,
        title: 'Padrón 1926 Serie',
        subTitle: 'Наградената с награди серия Padrón 1926 премиерира през 2002 г. в чест на 75-ия рожден ден на José O. Padrón, с десет налични размера. Продължавайки нашата традиция, тази серия се предлага в пресован формат. Тези пури са ръчно изработени от тютюн на възраст пет години, след което се смесват, за да създадат изключително гладък, сложен, балансиран и плътен вкус. За защита на всяка пура се прилага двойна лента с индивидуално номериран гаранционен етикет, за да се предпази от фалшифициране. Предлага се както в естествени, така и в мадуро опаковки.',
        imgUrl: Padron1926,
        imagBg: Padron_1926,
        cigars: [
            {
                id: 1,
                title: 'No 1',
                subtitle: '54 x 6 3/4',
                img: No1,
                openBox: No1Open,
                closedBox: No1Closed,
            },
            {
                id: 2,
                title: 'No 9',
                subtitle: '56 x 5 1/4   2007 Cigar Aficionado Cigar of The Year',
                img: No9,
                openBox: No9Open,
                closedBox: No9Closed,
            },
            {
                id: 3,
                title: 'No 2',
                subtitle: '52 x 5 1/2',
                img: No2,
                openBox: No2Open,
                closedBox: No2Closed,
            },
            {
                id: 4,
                title: 'No 6',
                subtitle: '50 x 4 3/4',
                img: No6,
                openBox: No6Open,
                closedBox: No6Closed,
            },
            {
                id: 5,
                title: 'No 35',
                subtitle: '48 x 4',
                img: No35,
                openBox: No35Open,
                closedBox: No35Closed,
            },
            {
                id: 6,
                title: 'No 40',
                subtitle: '54 x 6 1/2   2004 Cigar Aficionado Cigar of The Year',
                img: No40,
                openBox: No40Open,
                closedBox: No40Closed,
            }
        ]
    },
    {
        id: 5,
        title: 'Padrón Family Reserve',
        subTitle: 'Веднъж изключителна за Padrón’s, тази изключителна, индивидуално ръчно изработена поредица означава специални дати за семейни годишнини. Предлагайки пет високо оценени селекции, No. 44, 45, 46, 85 и 50 са красиво опаковани в десет броя кутии.',
        paragraphOne: `
        Предлага се както в естествена, така и в мадуро обвивка, тютюнът отлежава десет години, след което се смесва, за да създаде изключително гладък, сложен, балансиран и плътен вкус. За ваша защита на всяка пура се прилага двойна лента с индивидуално номериран гаранционен етикет, за да се предпази от фалшифициране.
        `,
        imgUrl: PadronFR_No45,
        imagBg: Padron_FamReserev,
        cigars: [
            {
                id: 1,
                title: 'No 44',
                subtitle: '52 x 6',
                img: No44,
                openBox: No44Open,
                closedBox: No44Closed,
            },
            {
                id: 2,
                title: 'No 45',
                subtitle: '52 x 6   2009 Cigar Aficionado Cigar of The Year',
                img: No45,
                openBox: No45Open,
                closedBox: No45Closed,
            },
            {
                id: 3,
                title: 'No 46',
                subtitle: '56 x 5 1/2',
                img: No46,
                openBox: No46Open,
                closedBox: No46Closed,
            },
            {
                id: 4,
                title: 'No 85',
                subtitle: '50 x 5 1/4',
                img: No85,
                openBox: No85Open,
                closedBox: No85Closed,
            },
            {
                id: 5,
                title: 'No 50',
                subtitle: '54 x 5',
                img: No50,
                openBox: No50Open,
                closedBox: No50Closed,
            }

        ]
    },
    {
        id: 6,
        title: 'Padron 50th Ann',
        subTitle: 'Това ограничено производство и регистриран хумидор, издаден през 2014 г., отбелязва честването на нашата 50-годишнина с предложение от 1000 сандъка, всеки съдържащ 50 последователно номерирани пури.',
        paragraphOne: `
        Първоначалната версия предлагаше червени последователни серийни номера на пури, съответстващи на всеки номер на хумидор. Последващите издания са достъпни само като регистрирано зареждане с хумидор, имат черен цвят и не са последователни.
        `,
        paragraphTwo: `
        Уникалната смес е с плътно тяло, сложна, но балансирана, създадена изключително за честване на нашата 50-годишнина. Отлежала минимум десет години, пурата 50th Anniversary се предлага в отгледана от слънце естествена или мадуро обвивка. За наличност се свържете с местния оторизиран търговец на Padrón.            `,
        imgUrl: Padron50thAnn,
        imagBg: Padron_50Anniversary,
        cigars: [
            {
                id: 1,
                title: '50th Anniversary ',
                subtitle: '52 x 6 1/2  50 cigar humidor',
                img: Padron_50,
                openBox: Padron_50Open,
                closedBox: Padron_50Closed,
            }



        ]
    }
]